<!-- prettier-ignore -->
<div class="breadcrumb-bar">
  <app-breadcrumb [titles]="[{ label: 'レビュー一覧' }]"></app-breadcrumb>

  @if (targetHospitalName) {
    <span class="hospital-badge" aria-label="対象施設名">
      {{ targetHospitalName }}
    </span>
  }
</div>

<!-- prettier-ignore -->
<div class="content-block">
  @let state = (reviewState$ | async);
  @switch (state?.status) {
    @case('loading'){
      <app-skeleton type="table" />
      <app-spinner message="読み込み中" />
    }
    @case ('success') {
      @if(dataSource.data.length === 0) {
        <app-skeleton
          type="table"
          [messages]="['レビュー一覧データが登録されていません']"
        />
      } @else {
        <ng-container>
          @let patch = (patchState$ | async);
          @let isSaving = patch?.status === 'saving';
          @let isProcessing = selectedItem?.status === 'processing';
          @let canRegister = selectedItem?.reviewResult === null;
          @if (isSaving) { <app-spinner message="登録中" /> }

          <app-shared-table
            #table="sharedTable"
            [dataSource]="dataSource"
            [columns]="columns"
            [displayedColumns]="displayedColumns"
            [selectedRow]="selectedItem"
            (rowClick)="onSelect($event)">
          </app-shared-table>

          <div class="edit-form">
            <form [formGroup]="editForm" novalidate>
            <div class="form-row">
              <label class="form-label" for="id">管理番号</label>
              <div class="form-value">
                <span
                  class="fixed-value"
                  id="id"
                  [ngClass]="{ 'read-only': isReadOnly }"
                >
                  {{ selectedItem?.id | idFormat }}
                </span>
              </div>

              @if (isProcessing) {
                <button
                  type="button"
                  class="button-detail"
                  [disabled]="isSaving"
                  (click)="goToDetail(selectedItem!.id)"
                >
                  <div class="button-detail-inner">
                  <svg class="table-icon" viewBox="0 0 24 24">
                    <path [attr.d]="mdiTable" />
                  </svg>
                  <span class="button-detail-text">データ一覧を開く</span>
                  </div>
                </button>
              }
            </div>

            <div class="form-row">
              <label class="form-label" for="created">作成日</label>
              <div class="form-value">
                <span
                  class="fixed-value"
                  id="created"
                  [ngClass]="{ 'read-only': isReadOnly }"
                >
                  {{ selectedItem?.created | yyyyMMddFormat }}
                </span>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label" for="reviewResult">
                承認ステータス 
                @if (isProcessing && canRegister) {
                  <span class="required">*</span> 
                }
              </label>

              <div
                class="radio-wrapper"
                [class.radio-error]="editForm.get('reviewResult')?.invalid && editForm.get('reviewResult')?.touched"
                [class.readonly]="isReadOnly"
              >
                <mat-radio-group
                  formControlName="reviewResult"
                  name="radio-group"
                  aria-labelledby="reviewResult-label"
                >
                  <mat-radio-button value="approved">承認 &nbsp;&nbsp;&nbsp; {{ approvalDefinitions }}</mat-radio-button>
                  <mat-radio-button value="rejected">却下</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>

            <div class="form-row">
              <mat-label class="form-label comment-label">コメント</mat-label>
              <mat-form-field appearance="outline" class="comment-field app-field">
                <textarea
                  matInput
                  formControlName="comment"
                  rows="3"
                  [placeholder]="isProcessing && canRegister ? 'コメントを入力してください' : ''"
                  maxlength="300"
                >
                </textarea>
              </mat-form-field>
            </div>

            <div class="form-row form-row--last">
              <label class="form-label reviewed-date-label" for="reviewed-date">
                承認・却下日 
                @if (isProcessing && canRegister) {
                  <span class="required">*</span> 
                }
              </label>

              <div class="form-value with-button">
                <mat-form-field appearance="outline" class="date-field app-field">
                  @if (isReadOnly === false) {
                    <mat-datepicker-toggle
                    matSuffix
                    [for]="datePicker"
                    ></mat-datepicker-toggle>
                  }
                  <input
                  id="reviewed-date"
                  matInput
                  [matDatepicker]="datePicker"
                  formControlName="reviewed"
                  [max]="today"
                  />
                  <mat-datepicker #datePicker></mat-datepicker>
                </mat-form-field>

                <div class="button-wrapper">
                  @if (canRegister) {
                  <button
                    mat-flat-button
                    type="button"
                    (click)="saveEdit()"
                    [disabled]="isSaving"
                  >
                    登録
                  </button>
                  }
                </div>
              </div>
            </div>

            <div class="form-error-message" [class.visible]="submitted && editForm.invalid">
              {{errorMessage}}
            </div>
            </form>
          </div>
          <br />
        </ng-container>
      }
    } 
    @case ('error') {
      <app-skeleton
      type="alert"
      [messages]="['レビュー一覧データの取得に失敗しました。','しばらくしてから再度お試しください。']"
      />
    } 
  }
</div>
